import React, { FC } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { saveCustomer } from 'actions/customerSearch';
import { closeModalPage } from 'actions/modalPage';
import SaveButton from 'components/CustomButtons/SaveButton';
import InputField from 'components/FieldTypes/InputField';
import { useShortcut } from 'utils/hooks/keyboard/useShortcut';
import { addSuccess } from 'actions/Error';
import { getSelectedWarehouseID } from 'reducers/warehouses';
import { getPrefillHomeStoreOnCustomerCreation } from 'reducers/configs/settings';

export const CompanyCreation: FC<{
  onChange: any;
  companyData: any;
}> = ({ companyData, onChange }) => {
  const { t } = useTranslation('scanSearchResults');
  const dispatch = useDispatch();
  const whID = useSelector(getSelectedWarehouseID);
  const prefillHomeStore = useSelector(getPrefillHomeStoreOnCustomerCreation);

  const handleChange = e => {
    const { name, value } = e.target;
    onChange(name, value);
  };

  const handleSubmit = async () => {
    await dispatch(
      saveCustomer(
        {
          ...companyData,
          signUpStoreID: whID,
          homeStoreID: prefillHomeStore ? whID : undefined,
        },
        () => {
          dispatch(addSuccess(t('warnings.customerCreated')));
          return dispatch(closeModalPage());
        },
      ),
    );
  };

  useShortcut('confirm', () => handleSubmit(), 30);

  return (
    <>
      <Form onSubmit={() => handleSubmit()}>
        <Form.Group>
          <InputField
            size="lg"
            title={t('inputs.company.companyName')}
            type="text"
            name="companyName"
            onChange={e => handleChange(e)}
            value={companyData.companyName}
          />
        </Form.Group>
        <Form.Group>
          <InputField
            size="lg"
            title={t('inputs.company.code')}
            name="code"
            type="text"
            onChange={e => handleChange(e)}
            value={companyData.code}
          />
        </Form.Group>
        <SaveButton action={handleSubmit} title={t('buttons.save')} />
      </Form>
    </>
  );
};
